angular.module('edxComponents')
  .component('edxQuantileAssignmentBlurb', {
    templateUrl: '/resources/components/assign-focus/create-quantile-assignment/quantile-assignment-blurb.component.html',
    controller: [QuantileAssignmentBlurbController],
    controllerAs: 'vm',
    bindings: {}
  });

function QuantileAssignmentBlurbController() {
}
